import React from "react";
import wave from "../assets/wave.svg";
import { WEBSITE_DATA } from "../constants/dashboard";
import "./Main.css";

const Main = () => {
  return (
    <div className="main">
      <img src={wave} className="waveImg" alt="wave" />
      <h2>{WEBSITE_DATA.headingPart1}</h2>
      <h1 className="main-heading">{WEBSITE_DATA.headingPart2}</h1>
      <p>{WEBSITE_DATA.subHeading}</p>
    </div>
  );
};

export default Main;
